import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="battle--team-form"
export default class extends Controller {
  static targets = [
    "teamSideInput",
  ]
  static values = { url: String };

  connect() {
    console.log(this.urlValue);
  }

  update(event) {
    const input = event.target;
    const field = input.dataset.field;
    const value = input.value;

    console.log("chaeed")

    // Build the request payload
    const data = {
      battle_team: {
        [field]: value,
      },
    };

    // Send a PATCH request to update the field
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
      },
      body: JSON.stringify(data),
    })
        .then((response) => {
          if (!response.ok) {
            console.error(`Failed to update ${field}`);
          } else {
            console.log(`Updated ${field}`);
          }
        })
        .catch((error) => {
          console.error("Error updating field:", error);
        });
  }
}
